import styled from 'styled-components';

const StyledHeroTextOnly = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: ${props => props.theme.components_spacing_desk.xxlarge}px;
  padding-top: calc( ${props => props.theme.components_spacing_tablet.xlarge}px + 94px);
  overflow: hidden;
  .hero-text--wrap{
    position: relative;
    padding-left: 50%;
    padding-right: 64px;
  }
  .hero-text--below{
    position: relative;
    margin-top: ${props => props.theme.components_spacing_desk.xxlarge}px;
    padding-left: ${ props =>  props.align === 'right' ? '64px' : '50%'};
    padding-right: ${ props =>  props.align === 'right' ? '50%' : '64px'};
  }
  .hero-text--below-landing{
    padding-right: 0;
    width: 66.66%;
  }
  .hero-text--wrap h5{
    margin-bottom: 40px;
  }
  h4.padding--bottom{
    padding-bottom: 40px
  }
  .hero-text--below h6 {
    margin-top: 80px;
    margin-bottom: 32px;
  }
  .hero-text--below p {
    color: ${ props =>  props.greyParagraph ? '#4D4D4D' : 'inherit'};
  }
  @media screen and (max-width: 1439px){
    .hero-text--wrap{
      padding-right: 40px;
    }
    .hero-text--below{
      padding-right: ${ props =>  props.align === 'right' ? '50%' : '64px'};
    }
    .hero-text--below-landing{
      padding-right: 0;
    }
  }
  @media screen and (max-width: 1023px){
    padding-bottom: ${props => props.theme.components_spacing_tablet.xxlarge}px;
    padding-top: calc( ${props => props.theme.components_spacing_tablet.xlarge}px + 94px);
    .hero-text--image{
      margin: ${props => props.theme.components_spacing_tablet.xlarge}px 0;
      &.zero--bottom{
        margin-bottom: 0;
      }
    }
    .hero-text--wrap{
      padding-left: 40%;
      padding-right: 40px;
    }
    .hero-text--below{
      padding-left: ${ props =>  props.align === 'right' ? '40px' : '40%'};
      padding-right: ${ props =>  props.align === 'right' ? '40%' : '40px'};
      margin-top: ${props => props.theme.components_spacing_tablet.xxlarge}px;
    }
    .hero-text--below-landing{
      padding-right: 0;
    }
    .hero-text--below h6 {
      margin-top: 60px;
    }
  }
  @media screen and (max-width: 767px){
    padding-bottom: ${props => props.theme.components_spacing_mobile.xxlarge}px;
    padding-top: calc( ${props => props.theme.components_spacing_mobile.xlarge}px + 81px);
    .hero-text--image{
      margin: 80px 0;
      &.zero--bottom{
        margin-bottom: 0;
      }
    }
    .hero-text--wrap, 
    .hero-text--below{
      padding: 0 24px;
    }
    .hero-text--below{
      margin-top: ${props => props.theme.components_spacing_mobile.xxlarge}px;

    }
    .hero-text--below-landing{
      width: auto;
    }
    .hero-text--wrap h5{
      margin-bottom: 24px;
    }
    h4.padding--bottom{
      padding-bottom: 32px
    }
    .hero-text--below h6 {
      margin-top: 32px;
    }
  }
`;

export {
  StyledHeroTextOnly,
};

